import { axiosInstance } from '../../utils';
import { ContentDraft } from '../../@types';

interface Payload {
  audioId: string;
  avatarId: string;
  name: string;
}

export const saveDraft = async (payload: Payload): Promise<ContentDraft> => {
  const res = await axiosInstance.post('/api/videos/save-draft', payload);
  return res.data;
};
